import { useCallback, useState, useSyncExternalStore } from 'react';
import { Predicate } from 'effect';

const getServerHeight = () => 0;
const unsubscribeNoop = () => undefined;

export function useElementHeight<Element extends HTMLElement>() {
  const [element, setElement] = useState<Element | null>(null);
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!element || !Predicate.isFunction(globalThis.ResizeObserver))
        return unsubscribeNoop;
      const observer = new ResizeObserver(onChange);
      observer.observe(element);
      return () => observer.disconnect();
    },
    [element],
  );
  const getHeight = useCallback(() => element?.offsetHeight ?? 0, [element]);
  const height = useSyncExternalStore(subscribe, getHeight, getServerHeight);

  return { height, attach: setElement };
}
